import { FC, PropsWithChildren } from 'react';

export const MaterialGrid: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 w-full">
      {children}
    </div>
  );
};
